// extracted by mini-css-extract-plugin
module.exports = {"monthName":"MonthCaption_monthName__rBOOP"};